module.exports = __webpack_public_path__ + "img/gen3_ch.5832f0c5.png";